import { GitCompareArrows } from 'lucide-react';
import { Link } from 'react-router-dom';

import { useTranslation } from '@sshop/i18n';
import { cn } from '@sshop/ui';

import { MAX_COMPARE_PRODUCTS, useComparison } from '@/features/comparison/useComparison';
import { useLocale } from '@/shared/hooks/useLocale';
import { routes } from '@/shared/lib/routes';

import { compareButtonStyles as s } from './CompareButton.styles';

export function CompareButton() {
  const { t } = useTranslation();
  const locale = useLocale();
  const { items } = useComparison();
  const count = items.length;
  const label = count > 0 ? t('nav.compareCount', { count }) : t('nav.compare');

  return (
    <Link to={routes.compare(locale)} aria-label={label} title={label} className={s.root}>
      <GitCompareArrows className={s.icon} aria-hidden />
      {count > 0 ? (
        <span
          className={cn(s.badge, count >= MAX_COMPARE_PRODUCTS ? s.badgeFull : s.badgeAvailable)}
          aria-hidden
        >
          {count}
        </span>
      ) : null}
    </Link>
  );
}
